import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
	paper: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		backgroundColor: theme.palette.background.paper,
		width: "100%",
		borderRadius: "4px",
	},
	inputLabelRoot: {
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		maxWidth: "100%",
	},
	container: {
		borderRadius: "10px",
	},
	fw500: {
		fontWeight: 500,
	},
	p2: {
		padding: theme.spacing(2),
	},
	pr65: {
		paddingRight: "65px",
	},
	divider: {
		flexGrow: 1,
		borderTop: `3px solid ${theme.palette.grey[300]}`,
		marginLeft: theme.spacing(2),
		marginRight: theme.spacing(2),
	},
	w20: {
		width: "20%",
	},
	w30: {
		width: "30%",
	},
	w40: {
		width: "40%",
	},
	w50: {
		width: "50%",
	},
	w70: {
		width: "70%",
	},
	w90: {
		width: "90%",
	},
	prescriptionContent: {
		paddingLeft: theme.spacing(3),
		padding: theme.spacing(2),
	},
	borderIcon: {
		border: `1px solid ${theme.palette.grey[400]}`,
	},
	list: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		width: "100%",
	},
	icon: {
		marginRight: theme.spacing(2),
		border: `1px solid ${theme.palette.grey[400]}`,
	},
	root: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		width: "100%",
		padding: theme.spacing(1),
	},
	customBackground: {
		"&:hover, &.Mui-focusVisible": {
			backgroundColor: theme.palette.primary.dark,
		},
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.primary.contrastText,
	},
	iconDisabled: {
		marginRight: theme.spacing(2),
		border: `1px solid ${theme.palette.grey[400]}`,
		cursor: "default",
		"&:hover, &.Mui-focusVisible": {
			backgroundColor: theme.palette.background.paper,
		},
	},
	mtN1: {
		marginTop: -theme.spacing(1),
	},
	mbN2: {
		marginBottom: -theme.spacing(2),
	},
	avatar: {
		backgroundColor: theme.palette.primary.light,
		color: theme.palette.primary.dark,
	},
	avatarIcon: {
		marginRight: (props: any) => (!props.isDisabled ? theme.spacing(-6.5) : theme.spacing(-3)),
	},
	control: {
		backgroundColor: theme.palette.background.paper,
	},
	root2: {
		position: "relative",
		width: 276,
	},
	display: {
		position: "absolute",
		top: 2,
		right: 10,
		left: 10,
		bottom: 2,
		background: "white",
		pointerEvents: "none",
		display: "flex",
		alignItems: "center",
	},
	input: {},
}));
